import React, { useState } from "react";
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { format, addMonths, subMonths, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, endOfWeek } from "date-fns";

const Calendar = () => {
    const [currentDate, setCurrentDate] = useState(new Date());

    // Handle navigation to previous/next month
    const handlePrevMonth = () => setCurrentDate(subMonths(currentDate, 1));
    const handleNextMonth = () => setCurrentDate(addMonths(currentDate, 1));

    // Get the start and end of the current month
    const startOfMonthDate = startOfMonth(currentDate);
    const endOfMonthDate = endOfMonth(currentDate);

    // Generate all the days for the current month
    const daysInMonth = eachDayOfInterval({
        start: startOfMonthDate,
        end: endOfMonthDate
    });

    // Determine the first and last day of the week to create a complete calendar grid
    const startOfCalendar = startOfWeek(startOfMonthDate);
    const endOfCalendar = endOfWeek(endOfMonthDate);

    // Generate the full grid of days, including leading and trailing empty days (for a complete grid)
    const daysGrid = eachDayOfInterval({ start: startOfCalendar, end: endOfCalendar });

    const monthName = format(currentDate, "MMMM yyyy");

    const today = new Date(); // Get today's date

    return (
        <div className="calendar-container">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">{monthName}</h2>
                <div className="flex text-[#000] text-xl">
                    <MdKeyboardArrowLeft size={30} onClick={handlePrevMonth} />
                    <MdOutlineKeyboardArrowRight size={30} onClick={handleNextMonth} />
                </div>
            </div>



            {/* Calendar Body */}
            <div className="calendar-body">
                <div className="grid grid-cols-7 gap-1">
                    {/* Days of the week header */}
                    <div className="font-bold text-center">Sun</div>
                    <div className="font-bold text-center">Mon</div>
                    <div className="font-bold text-center">Tue</div>
                    <div className="font-bold text-center">Wed</div>
                    <div className="font-bold text-center">Thu</div>
                    <div className="font-bold text-center">Fri</div>
                    <div className="font-bold text-center">Sat</div>
                </div>

                {/* Horizontal Line */}
                <hr className="my-3 border-t-1 border-gray-300" />

                {/* Grid of Days */}
                <div className="grid grid-cols-7 gap-1">
                    {daysGrid.map((day, index) => {
                        const isCurrentMonth = day.getMonth() === currentDate.getMonth();
                        const isToday = today.toDateString() === day.toDateString(); // Check if it's today
                        const dayClass = isCurrentMonth
                            ? isToday
                                ? "text-white bg-blue-500 rounded-full" // Highlight today's date
                                : "text-black"
                            : "text-gray-400"; // Dim days from other months

                        return (
                            <div
                                key={index}
                                className={`text-center py-4 cursor-pointer ${dayClass}`}
                                onClick={() => handleDayClick(day)}
                            >
                                {format(day, "d")}
                            </div>
                        );
                    })}
                </div>
            </div>

        </div>
    );
};

const handleDayClick = (day) => {
    //alert(`You clicked on ${format(day, "MMMM d, yyyy")}`);
};

export default Calendar;
